<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                      <div class="card-header border-0">
                        <div class="row align-items-center">
                          <div class="col head">
                            <h3 class="mb-0">
                              Estoque / Fornecedores
                            </h3>

                            <base-button :to="'/estoque-fornecedor/f'" type="default" icon="fas fa-plus" size="md" title="Adicionar Item"></base-button>
                          </div>
                        </div>
                      </div>

                      <div class="table-responsive">
                        <template>
                          <base-table class="table align-items-center table-flush"
                                      tbody-classes="list"
                                      :data="estoqueList">
                            <template slot="columns">
                              <th>ID</th>
                              <th>Descritivo</th>
                              <th class="text-center">Data de Cadastro</th>
                              <th class="text-center">Ações</th>
                            </template>

                            <template slot-scope="{row}">
                              <th scope="row">
                                <span>{{ row.id }}</span>
                              </th>
                              <td>
                                {{ row.descritivo }}
                              </td>
                              <td class="text-center">
                                <span class="name mb-0 text-sm"> {{formatarData(row.created_at)}}</span>
                              </td>
                              <td class="text-center">
                                  <base-button :to="'/estoque-categoria/f/'+row.id" type="default" icon="far fa-eye" size="sm" title="Visualizar item"></base-button>

                                  <base-button type="warning" icon="fas fa-trash" size="sm" title="Remover" @click="remove(row.id)"></base-button>
                              </td>

                            </template>

                          </base-table>
                        </template>
                      </div>

                       <template v-if="loading">
                          <div class="m-2">
                            <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                          </div>
                        </template>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import estoque from '@/cflow/estoque-cat.js'
  import storage from 'storage';
  //import parametros from "@/cflow/parametros.js";
  import BaseButton from '../../components/BaseButton.vue';

  export default {
    name: 'tables',
    components: {
      BaseButton
    },
    methods: {
      getLabId: function() {
        let lab_id = 0;
        var user = storage.get("user");
        if(user.tipo == 'lab') lab_id = user.id;
        return lab_id;
      },
      initLoad: function() {
        this.loading = true;
        const lab_id = this.getLabId();
      
        Promise.all([estoque.listar('FORNECEDOR', lab_id)]).then( res => {
          this.estoqueList = res[0];
          this.loading = false;
        })
      },
      remove(_id) {
        const hasConfirm = confirm('Tem certeza que deseja excluir este item?');

        if(hasConfirm) {
          Promise.all([estoque.remove(_id)]).then( () => {
            this.initLoad(0, 0);
          })
        }
      }
    },
    data() {
      return {
        loading: false,
        estoqueList:[]
      }
    },
    mounted(){
      this.initLoad(0, 0);
    }
  };
</script>
<style lang="scss" scoped>
.filtros .form-group{
  width: 150px;
}
.head {
  display: flex;
  justify-content: space-between;
}
</style>
